module.exports = __webpack_public_path__ + "img/draw.90173521.png";